import { useEffect, useState } from "react";
import { api, apiError, fmtDate } from "./api";
import { Card, PageHead, Pill, Select, Empty } from "./widgets";
import { toast } from "sonner";

const STATUSES = ["new", "read", "replied", "archived"];
const TONE = { new: "champagne", read: "blue", replied: "green", archived: "gray" };

const Messages = () => {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/admin/messages").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => {
    load();
  }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/messages/${id}`, { status });
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <div data-testid="messages-page">
      <PageHead title="Messages" sub="Every contact form submission, in one place." />
      {!items ? (
        <p className="text-sm text-[#171717]/50">Loading…</p>
      ) : items.length === 0 ? (
        <Empty>No messages yet.</Empty>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <Card key={m.id} className="cursor-pointer transition-colors hover:border-[#C6A46A]/60" data-testid={`message-${m.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-3" onClick={() => setOpen(open === m.id ? null : m.id)}>
                <div>
                  <p className="text-sm text-[#171717]">{m.name} <span className="text-[#171717]/45">— {m.subject}</span></p>
                  <p className="mt-0.5 text-xs text-[#171717]/50">{m.email} · {m.phone} · {fmtDate(m.createdAt)}</p>
                </div>
                <div className="flex items-center gap-3" onClick={(e) => e.stopPropagation()}>
                  <Pill tone={TONE[m.status]}>{m.status}</Pill>
                  <Select value={m.status} onChange={(e) => setStatus(m.id, e.target.value)} data-testid={`message-status-${m.id}`}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </Select>
                </div>
              </div>
              {open === m.id && (
                <p className="mt-4 border-t border-[#171717]/10 pt-4 text-sm leading-relaxed text-[#171717]/70">
                  {m.message || "(No message text)"}
                </p>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Messages;
